const frontendPort = 8080;
const websocketPort = 3150;
const backendPort = 3150;

const backendUrl = `https://api.noc-ops.mtnw.com.br`;
const backendSocket = `wss://api.noc-ops.mtnw.com.br/ws`;
const frontendUrl = `https://noc-ops.mtnw.com.br`;

const metroCompanyId = 13;

export {
  backendPort,
  frontendPort,
  backendUrl,
  frontendUrl,
  websocketPort,
  backendSocket,
  metroCompanyId
};
